import http from "../http-common";

class ApplicationDataService {
  getAll(payload) {
    const { page, filter } = payload;
    const keyword =
      filter?.search === "" || filter?.search === undefined
        ? ""
        : `&keyword=${filter?.search}`;
    return http.get(
      `/api/v1/backoffice/eapplication/list/all?page=${page}${keyword}`
    );
  }

  getdetail(id) {
    return http.get("/api/v1/backoffice/eapplication/detail/" + id);
  }

  updateStatus(id, data) {
    return http.post(
      "/api/v1/backoffice/eapplication/status/update/" + id,
      data
    );
  }

  assignApplication(id, data) {
    return http.post("/api/v1/backoffice/eapplication/assign/" + id, data);
  }

  updateNumber(id, data) {
    return http.post(
      "/api/v1/backoffice/eapplication/callno/update/" + id,
      data
    );
  }

  getStages(type, id) {
    return http.get("/api/v1/stage/list?type=" + type + "&id=" + id);
  }
}

export default new ApplicationDataService();
